import { ScreenBase } from "@frui.ts/screens";
import { action, observable } from "mobx";

export default abstract class ConfirmViewModel extends ScreenBase {
  @observable isOpened = false;
  private onResult: (value: boolean) => void;

  get canBeNavigationActiveScreen() {
    return false;
  }

  @action.bound public showConfirmation() {
    this.isOpened = true;
    return new Promise<boolean>(resolve => {
      this.onResult = resolve;
    });
  }

  @action.bound confirm() {
    this.isOpened = false;
    this.onResult(true);
  }

  @action.bound cancel() {
    this.isOpened = false;
    this.onResult(false);
  }
}
